import React from 'react';
import '../styles/GuideFeedback.css';

const GuideFeedback = () => {
    const recipientEmail = "wodecki.sg@gmail.com";
    const subject = "Ideas for New Guides";
    const body = "Hi Rasmoose Team,\n\nI have some ideas for new guides I'd like to see:\n\n- ";

    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    return (
        <div className="feedback-container">
            <div className="feedback-content">
                <h4>Have an idea for another guide?</h4>
                <p>We'd love to hear it! Send us your suggestions to help us build a better resource for all students.</p>
                <a href={mailtoLink} className="feedback-button">
                    Send Us Your Ideas
                </a>
            </div>
        </div>
    );
};

export default GuideFeedback;
